import { render, staticRenderFns } from "./data.vue?vue&type=template&id=023c3768&scoped=true"
import script from "./data.vue?vue&type=script&lang=ts"
export * from "./data.vue?vue&type=script&lang=ts"
import style0 from "./data.vue?vue&type=style&index=0&id=023c3768&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "023c3768",
  null
  
)

export default component.exports